import styled from "styled-components";
import { font, Theme } from "../../utils/themes";

// Define the theme interface to get type support for theme props
// interface Theme {
//   danger: string;
//   inputBorder: string;
//   headingColor: string;
//   inputColor: string;
//   primaryLight2: string;
//   inputPlaceHolder: string;
//   primary: string;
//   white: string;
// }

// Props interface for StyledInput
interface StyledInputProps {
  $borderWidth?: string;
  $fontSize?: string;
  $fontWeight?: string;
  $phFontSize?: string;
  $phFontWeight?: string;
  isInvalid?: boolean;
  borderColor?: string;
}

const StyledInput = styled.input<StyledInputProps & { theme: Theme, color?: string }>`
  padding: 8px 14px;
  auto-fill: false;
  font-size: ${({ $fontSize }) => $fontSize ?? "14px"};
  width: 100%;
font-family: ${font.raleway};
  background-color: ${({ theme }) => theme?.CorporateTheme?.colors?.filterBG};
  border-radius: 5px;
  border: ${({ $borderWidth }) => $borderWidth ?? "1.5px"} solid
    ${({ isInvalid, theme, borderColor }) => (isInvalid ? "#ef4444" : borderColor ?? theme?.CreateFormTheme?.colors?.inputBorders)};

  display: flex;
  align-items: center;
  color: ${({ color, theme }) => color ?? theme?.CorporateTheme?.colors?.textSecondary};
  font-weight: ${({ $fontWeight }) => $fontWeight ?? "400"};

  &:focus {
    outline: none;
    box-shadow: none;
    background-color: ${({ theme }) => theme?.CorporateTheme?.colors?.filterBG};
    color: ${({ color, theme }) => color ?? theme?.CorporateTheme?.colors?.textSecondary};
  }

  &:valid {
    background-image: none;
  }




  &::placeholder {
    color: #626262;
    font-size: ${({ $phFontSize }) => $phFontSize ?? "14px"};
    font-weight: ${({ $phFontWeight }) => $phFontWeight ?? "400"};
    
    opacity: 1;
  }

  :-webkit-autofill {
    -webkit-box-shadow: 0 0 0px 1000px white inset !important;
    -webkit-text-fill-color: black !important;
  }

  :-webkit-autofill:focus {
    -webkit-box-shadow: 0 0 0px 1000px white inset !important;
    -webkit-text-fill-color: black !important;
  }

  :-webkit-autofill:hover {
    -webkit-box-shadow: 0 0 0px 1000px white inset !important;
    -webkit-text-fill-color: black !important;
  }

  :-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0px 1000px white inset !important;
    -webkit-text-fill-color: black !important;
  }

  input[type="time"] {
  appearance: none; /* Removes default styling in modern browsers */
  -moz-appearance: textfield; /* For Firefox */
  -webkit-appearance: none; /* For Chrome, Safari, Edge */
}

 input[type="time"]::-webkit-calendar-picker-indicator {
  display: none; /* Hides the dropdown/clock icon */
}
`;

export default StyledInput;
